// extracted by mini-css-extract-plugin
export var breadcrumb = "_4iBQW";
export var categoryPageTitle = "VfU1J";
export var descriptionParagraph = "l-AKF";
export var header = "BQune";
export var subcategoryNavigation = "eeA7I";